import { Bell } from '@phosphor-icons/react'
import { IconButton } from '@shopflo/ui'
import React, { useEffect, useState, useLayoutEffect, useRef } from 'react'

const appID = process.env.NEXT_PUBLIC_CANNY_APP_ID
const NewsWidget: React.FC<{}> = ({}) => {
  useLayoutEffect(() => {
    ;(window as any).Canny('initChangelog', {
      appID: appID,
      position: 'bottom',
      align: 'left',
      theme: 'light'
    })
  }, [])

  return (
    <div className='relative  cursor-pointer ml-auto'>
      <div data-canny-changelog>
        <IconButton IconComponent={Bell} size='sm' variant='ghost' className='text-zinc-500 bg-gray-100' />
      </div>
    </div>
  )
}

export default NewsWidget
